import { useMutation } from "@apollo/client";
import { Reservation } from "@types";
import UpdateClientReservationMutation from "./UpdateClientReservationMutation.gql";

interface UpdateClientReservationPayload {
  success?: boolean;
  errorMessage?: string;
  clientReservation?: Reservation | null;
}

interface UpdateClientReservationResponse {
  updateClientReservation?: UpdateClientReservationPayload;
}

const useUpdateClientReservation = () => {
  const [mutate, { loading }] = useMutation<UpdateClientReservationResponse>(
    UpdateClientReservationMutation,
  );

  const updateClientReservation = async (
    floor: number | null,
  ): Promise<Reservation> => {
    const { data } = await mutate({
      variables: { floor },
    });

    const payload = data?.updateClientReservation;

    if (!payload?.success || !payload.clientReservation) {
      throw new Error(payload?.errorMessage || "Une erreur est survenue");
    }

    return payload.clientReservation;
  };

  return {
    updateClientReservation,
    loading,
  };
};

export default useUpdateClientReservation;